import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsTimeline from "highcharts/modules/timeline";
import HighchartsExporting from "highcharts/modules/exporting";
import { Options, SeriesTimelineOptions } from "highcharts";

// فعال‌سازی ماژول تایم‌لاین
if (typeof Highcharts === "object") {
  HighchartsTimeline(Highcharts);
  HighchartsExporting(Highcharts);
}

interface TimelineEvent {
  name: string;
  date: string;
  timeLineDescription?: string;
  color?: string;
  icon?: string;
  id: string;
  plantingDate: string ;
}

interface TimelineChartProps {
  events: TimelineEvent[];
  onEventClick?: (id: string) => void;
}

const TimelineChart: React.FC<TimelineChartProps> = ({
  events,
  onEventClick, 
}) => {

  

  const [selectedEventId , setSelectedEventId] = useState<string | null>(null)

  // تنظیمات چارت
  const options: Options = {
    chart: {
      type: "timeline",
    },
    exporting: {
      enabled: false,
    },
    title: {
      text: "فصل رشد",
      style:{color: "white"}
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      gridLineWidth: 3,
      title: undefined,
      labels: {
        enabled: true,
      },
    },

    plotOptions: {
      series: {
        cursor: "pointer",
        point: {
          events: {
            
            click: function () {
               const clickedEvent = events.find(event => event.id === this.options.id);
               if (clickedEvent) {
                setSelectedEventId(clickedEvent.id) 
              if (onEventClick) onEventClick(clickedEvent.id); 
               }else {
                console.log("Event not found")
               }
            },
          },
        },
      },
    },

    series: [
      {
        cursor: "pointer",
        type: "timeline", 
        data: events.map((event) => ({
          id: event.id,
          name: event.timeLineDescription,
          label: event.name,
          description: event.plantingDate + " :تاریخ کاشت" ,
          color: event.color,
          marker: {
            symbol: event.icon ? `url(${event.icon})` : undefined,
            width: 40,
            height: 40,
          },
          
        })),
      } as SeriesTimelineOptions, // تایپ سری به عنوان تایم‌لاین
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default TimelineChart;
